import React, {useCallback, useState, useMemo, useEffect} from 'react';
import {createPortal} from 'react-dom';
import {CircularProgress, Stack, Typography} from '@mui/material';

const LoaderContext = React.createContext([]);

export const useLoader = ()=>React.useContext(LoaderContext);

const CONTAINER_STYLE = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: Number.MAX_SAFE_INTEGER,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    cursor: 'wait',
};

const LOADER_STYLE = {
    'svg circle': {stroke: 'url(#loader_gradient)'},
};

const Loader = props=>{
    let {loading, text=''} = props;
    if (!loading)
        return null;
    return createPortal(<Stack
      justifyContent="center"
      alignItems="center"
      gap={2}
      sx={CONTAINER_STYLE}>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="loader_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#e01cd5"/>
            <stop offset="100%" stopColor="#1CB5E0"/>
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress size={100} sx={LOADER_STYLE}/>
      <Typography sx={{color: 'white'}}>{text}</Typography>
    </Stack>, document.body);
};

export const LoaderProvider = props=>{
    let {children} = props;
    let [tasks, setTasks] = useState([]);
    let loading = useMemo(()=>!!tasks.length, [tasks]);
    let text = useMemo(()=>{
        for (let i = tasks.length-1; i>=0; i--) {
            if (tasks[i].text)
                return tasks[i].text;
        }
    });
    let start = useCallback(text=>{
        let id = Symbol();
        setTasks(prev=>[...prev, {id, text}]);
        return ()=>setTasks(prev=>prev.filter(t=>t.id!==id));
    }, [])
    let ctx = useMemo(()=>[start, loading], [start, loading]);
    return <LoaderContext.Provider value={ctx}>
      {children}
      <Loader loading={loading} text={text}/>
    </LoaderContext.Provider>;
};

export const useLoaderState = (state, text)=>{
    let [start] = useLoader();
    return useEffect(()=>{
        if (!state||!start)
            return;
        return start(text);
    }, [state, start, text]);
};
